import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectCarFragment = { __typename?: 'Car', id: string, year?: number | null, make?: string | null, model?: string | null, colour?: string | null, vin?: string | null, licensePlate?: string | null };

export type ListCarsForCustomerQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ListCarsForCustomerQuery = { __typename?: 'Query', listCars: { __typename?: 'CarListReturn', offset?: number | null, items: Array<{ __typename?: 'Car', make?: string | null, model?: string | null, year?: number | null, colour?: string | null, id: string, createdAt: any, vin?: string | null, licensePlate?: string | null, trim?: string | null }> } };

export const SelectCarFragmentDoc = gql`
    fragment SelectCar on Car {
  id
  year
  make
  model
  colour
  vin
  licensePlate
}
    `;
export const ListCarsForCustomerDocument = gql`
    query ListCarsForCustomer($customerId: String!, $offset: Int) {
  listCars(customerId: $customerId, offset: $offset) {
    items {
      make
      model
      year
      colour
      id
      createdAt
      vin
      licensePlate
      trim
    }
    offset
  }
}
    `;

/**
 * __useListCarsForCustomerQuery__
 *
 * To run a query within a React component, call `useListCarsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCarsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCarsForCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListCarsForCustomerQuery(baseOptions: Apollo.QueryHookOptions<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables> & ({ variables: ListCarsForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>(ListCarsForCustomerDocument, options);
      }
export function useListCarsForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>(ListCarsForCustomerDocument, options);
        }
export function useListCarsForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>(ListCarsForCustomerDocument, options);
        }
export type ListCarsForCustomerQueryHookResult = ReturnType<typeof useListCarsForCustomerQuery>;
export type ListCarsForCustomerLazyQueryHookResult = ReturnType<typeof useListCarsForCustomerLazyQuery>;
export type ListCarsForCustomerSuspenseQueryHookResult = ReturnType<typeof useListCarsForCustomerSuspenseQuery>;
export type ListCarsForCustomerQueryResult = Apollo.QueryResult<ListCarsForCustomerQuery, ListCarsForCustomerQueryVariables>;